import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, LogIn } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errText } from "./api";
import { Field, Input } from "./ui";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await adminApi.login(email, password);
      localStorage.setItem("admin_token", u.token);
      toast.success("Welcome back, admin!");
      navigate("/admin");
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-[#073c1b] border border-[#1c5f35] rounded-3xl p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-6">
          <img src="/images/games/maha-games-logo-w128.webp" alt="logo" className="w-11 h-11 rounded-xl" />
          <div>
            <h1 className="text-xl font-extrabold text-white">Admin Login</h1>
            <p className="text-xs text-emerald-50/60">Maha Games Apps control panel</p>
          </div>
        </div>
        <Field label="Email" icon={Mail}>
          <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="admin@..." />
        </Field>
        <Field label="Password" icon={Lock}>
          <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
        </Field>
        <button data-testid="admin-login-submit" disabled={busy} className="mt-2 w-full flex items-center justify-center gap-2 bg-[#ffb224] hover:bg-[#ffc14d] disabled:opacity-60 text-[#062a13] font-extrabold py-3 rounded-xl border-b-[4px] border-[#b47400] active:border-b-0 active:translate-y-[4px] transition-all">
          <LogIn size={18} /> {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
